import React, { Component } from 'react';
import { Divider, Button, Slider, FormGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class GMConsole extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      MaxOptLevelGM: 8,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          GM Console
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>
                <FormGroup helperText="for GM Console">
                  Maximum Item Plus
                </FormGroup>
              </td>
              <td style={{ width: '360px' }}>
                <Slider
                  min={0}
                  max={255}
                  labelStepSize={30}
                  onChange={this.handleChange('MaxOptLevelGM')}
                  value={this.state.MaxOptLevelGM}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
